import { render, staticRenderFns } from "./fourthGuide.vue?vue&type=template&id=71bbd092&scoped=true"
import script from "./fourthGuide.vue?vue&type=script&lang=js"
export * from "./fourthGuide.vue?vue&type=script&lang=js"
import style0 from "./fourthGuide.vue?vue&type=style&index=0&id=71bbd092&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71bbd092",
  null
  
)

export default component.exports